


















import {
    defineComponent,
    ref,
    Ref,
    watch,
    onBeforeMount,
} from '@vue/composition-api';
import { getLocaleRedirectUrl } from '@app/localization/setLocale';
import HtmlPage from '@app/rawHtmlPages/components/HtmlPage';
import { RawHtmlPage } from '@src/app/rawHtmlPages/types';
import { localeMap } from '@src/config/locale';
import { useClickOutside } from '@src/app/utils/useClickOutside';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import { SelectableLocale } from '@src/config/shell/localConfigTypes';
import { getShellConfig } from '@src/config/shell/config';
import { currentSite } from '@src/app/utils/domainHelpers';
import { Site } from '@superbet-group/web.types';
import { RouteName } from '@src/app/router/constants/RouteName';
import { getRawHtmlPage } from '@app/rawHtmlPages/services/rawHtmlPages';
import { nativeUrlOverrides } from '@app/mobile/helpers/navigation';
import { SiteLanguageConfig } from '@modules/app/siteLanguage/siteLanguageConfig';

const modifyNapoleonLinks = {
    inserted(el) {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const isNativeOverride = urlSearchParams.get('nativeApps') === 'true';

        if (isNativeOverride) {
            const napoleonSportsLinks = el.querySelectorAll('.napoleonsports-link');
            const napoleonCasinoLinks = el.querySelectorAll('.napoleoncasino-link');

            const updateHref = (links: any, newHref: string) => {
                links.forEach((link: any) => {
                    const url = new URL(link.href);
                    url.href = newHref;
                    // eslint-disable-next-line no-param-reassign
                    link.href = url.toString();
                });
            };

            updateHref(napoleonSportsLinks, nativeUrlOverrides.sports);
            updateHref(napoleonCasinoLinks, nativeUrlOverrides.casino);
        }
    },
};

export default defineComponent({
    setup() {
        const page: Ref<RawHtmlPage | null> = ref(null);

        const dropdownRef = ref<HTMLElement | null>(null);
        const { isClickOutside } = useClickOutside(dropdownRef);

        watch(isClickOutside, (value) => {
            if (value) {
                isDropdownVisible.value = false;
            }
        });

        const isDropdownVisible = ref(false);
        const toggleDropdown = () => {
            isDropdownVisible.value = !isDropdownVisible.value;
        };

        const { route, router } = useVueRouter();
        const changeLanguage = (locale: SelectableLocale) => {
            window.location.href = getLocaleRedirectUrl(locale.value, route.value.path).href;
        };

        const currentLocale = getShellConfig().locale;
        const currentLanguage = localeMap[currentLocale].languageCode.toUpperCase();
        const otherLocales = SiteLanguageConfig.availableLocales.filter((locale) => locale.value !== getShellConfig().locale);

        onBeforeMount(async () => {
            if (currentSite !== Site.NapoleonGames) {
                router.value.replace({ name: RouteName.App.Home });
            }

            page.value = await getRawHtmlPage('hub');
        });

        const body = document.querySelector('body');
        if (body) {
            body.classList.add('napoleon-hub');
        }

        return {
            page,
            currentLanguage,
            otherLocales,
            isDropdownVisible,
            dropdownRef,

            toggleDropdown,
            changeLanguage,
        };
    },
    directives: {
        modifyOnRender: modifyNapoleonLinks,
    },
    components: {
        HtmlPage,
    },
});
